import Model from 'flarum/common/Model';
export default class Reward extends Model {
  amount = Model.attribute('amount');
  newMoney = Model.attribute('newMoney');
  comment = Model.attribute('comment');
  createdAt = Model.attribute('createdAt', Model.transformDate);
  post = Model.hasOne('post');
  giver = Model.hasOne('giver');
  receiver = Model.hasOne('receiver');
}
flarum.reg.add('clarkwinkelmann-money-rewards', 'forum/models/Reward', Reward);